import axios from '@/core/axios';

import { CadenceFilterOptions, CadenceQuery, CadenceResponse } from './production-cadences.types';

const compactParams = (params: object): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && !(Array.isArray(v) && v.length === 0))
  );

/* Module Analyses > Pilotage > Cadences production (backend ProductionCadence, cache 1 min) */
export class ProductionCadencesService {
  cadences(query: CadenceQuery = {}): Promise<CadenceResponse> {
    return axios
      .get<CadenceResponse>('/production-cadences', { params: compactParams(query) })
      .then(resp => resp?.data);
  }

  filterOptions(): Promise<CadenceFilterOptions> {
    return axios.get<CadenceFilterOptions>('/production-cadences/filter-options').then(resp => resp?.data);
  }
}

export const productionCadencesService = new ProductionCadencesService();
